export const woundAssessmentProgressChartDataActions = {
  populateWoundAssessmentProgressChartData:
    "POPULATE_WOUND_ASSESSMENTS_CHART_DATA",
  woundAssessmentProgressChartDataLoading:
    "DATA_WOUND_ASSESSMENT_PROGRESS_CHART_LOADING",
  woundAssessmentProgressChartDataLoadError:
    "DATA_WOUND_ASSESSMENT_PROGRESS_CHART_LOAD_ERROR"
};
